import { t } from "i18next";
import { FormCheckbox } from "../form/FormCheckbox";
import { ConversationType } from "../../enums/ConversationType";
import { ConversationFilter } from "../../models/ConversationFilter";
import Button from "../Button";
import { TrashIcon } from "@heroicons/react/24/solid";
import { useCallback } from "react";

export const ConversationFilters = (props: {
  filters: ConversationFilter;
  updateFilterValues: (x: ConversationFilter) => void;
}) => {
  const handleChange = (e: any) => {
    const updatedFilters = { ...props.filters };
    if (e.target.checked) {
      updatedFilters.selectedTypes = [
        ...updatedFilters.selectedTypes,
        e.target.name,
      ];
    } else {
      updatedFilters.selectedTypes = updatedFilters.selectedTypes.filter(
        (x) => x !== e.target.name
      );
    }
    props.updateFilterValues(updatedFilters);
  };

  const clearAll = useCallback(() => {
    props.updateFilterValues({ selectedTypes: [] });
  }, [props]);

  return (
    <div className="absolute top-14 bg-white h-fit w-[200px] rounded-md shadow-lg z-10 flex flex-col gap-1">
      <div className="p-2">
        <FormCheckbox
          checked={props.filters?.selectedTypes.includes(
            `${ConversationType.CLIENTS}`
          )}
          name={"" + ConversationType.CLIENTS}
          inlineDisplay
          handleOnChange={handleChange}
          label={t("CLIENTS")}
          isBig
        />
        <FormCheckbox
          checked={props.filters?.selectedTypes.includes(
            `${ConversationType.LEADS}`
          )}
          name={"" + ConversationType.LEADS}
          inlineDisplay
          handleOnChange={handleChange}
          label={t("LEADS")}
          isBig
        />
        <FormCheckbox
          checked={props.filters?.selectedTypes.includes(
            `${ConversationType.OTHER}`
          )}
          name={"" + ConversationType.OTHER}
          inlineDisplay
          handleOnChange={handleChange}
          label={t("OTHERS")}
          isBig
        />
         <Button iconOnly isSecondary onClick={clearAll} classNames="flex items-center shadow-none gap-2 px-2 mt-2"> 
            <TrashIcon className="text-asureis-gray w-6" />
            <div className="text-base text-asureis-gray pt-1">{t("CLEAR")}</div>
          </Button>
      </div>
    </div>
  );
};
